import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

import {Id} from './Product.style';
import {PriceWholeWrapper} from './ListProduct-v2.style';

const Info = styled.div`
  position: relative;
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${media.medium`
    margin-top: 0;
  `};
`;

// The card's own floor height. Exported because FeaturedProduct.style.js subtracts its strip from
// this number — the two have to be one value or a featured cell stops matching the row beside it.
export const CARD_MIN_HEIGHT = '26.5rem';

export const Container = styled.div`
  position: relative;
  width: 35rem;
  max-width: 35rem;
  min-height: ${CARD_MIN_HEIGHT};
  margin: 0.8rem 0;
  flex-direction: column;
  background-color: ${p => p.theme.tertiaryBgColor};
  display: flex;
  ${media.smaller`
    width: 100%;
    max-width: 100%;
    min-height: auto;
    margin-bottom: 1rem;
    margin: 0;
  `};
`;

export const ListViewContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  min-height: 18rem;
  ${media.small`
    min-height: 19rem;
  `}
  ${media.smaller`
    min-height: auto;
  `};
`;

export const Price = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  color: ${p =>
    p.$isOffer
      ? p.theme.tertiaryColor
      : p.$isFirstOffer
      ? p.theme.primaryColor
      : p.theme.quinaryTextColor};
  font-size: 1.4rem;
  align-items: baseline;
  ${media.small`
    font-size: 1.2rem;
    height: 1.2rem;
  `};
`;
export const Small = styled.span`
  font-size: 1rem;
  line-height: 1rem;
  font-weight: bold;
  text-transform: uppercase;
  color: ${p => p.theme.tertiaryTextColor};
  ${media.small`
    font-size: 1rem;
  `};
`;

export const StepBoxLabel = styled.span`
  text-transform: lowercase;
`;

export const SmallMatch = styled.span`
  font-size: 1.1rem;
  text-transform: capitalize;
  line-height: 1rem;
  padding-top: 0.3rem;
  padding-left: 1rem;
  font-weight: bold;
  ${media.small`
    font-size: 1rem;
    padding-right: 0.1rem;
  `};
`;

export const HideOnMobile = styled.span`
  ${media.small`
    display: none;
  `};
`;
export const Larger = styled.span`
  font-size: 1.2rem;
  font-weight: bold;
  ${media.small`
    font-size: 1.1rem;
  `};
`;

export const Content = styled.div`
  flex-grow: 1;
  padding: 0.7rem 1rem 0 0;
  text-align: center;
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  > *:last-child {
    margin-top: auto;
  }

  ${media.small`
    margin-top: -0.1rem;
    > *:last-child {
      margin-top: 0;
    }
  `};

  div[data-id='promotionSection'] {
    justify-content: flex-start;
  }
`;

export const Weight = styled.span`
  flex-grow: 1;
  font-size: 1rem;
  text-align: left;
  color: ${p =>
    p.$isOffer ? p.theme.tertiaryColor : p.theme.tertiaryTextColor};
  line-height: 1.8rem;
  padding-top: 0.4rem;
  min-width: 100%;
  ${media.small`
    margin-top: 0;
  `};
`;

export const PhotoWrapper = styled.div`
  position: relative;
  width: 12rem;
  height: 13rem;
  text-align: center;
  cursor: pointer;
  ${media.small`
    width: 15rem;
    min-width: 15rem;
    min-height: 15rem;
  `};
  ${media.smallest`
    display: flex;
    align-items: center;
  `};

  picture img {
    width: 12rem;
    height: 12rem;
    min-height: 12rem;
    min-width: 12rem;
    padding: 1rem;
    z-index: 1;
    ${media.small`
      width: 14rem;
      height: 14rem;
      min-width: 14rem;
      min-height: 14rem;
      max-height: 14rem;
    `};
    ${media.smallest`
      margin-left: 0;
    `};
  }
`;

export const ListViewInfo = styled(Info)`
  text-align: left;
`;

export const NameWrapper = styled.div`
  width: 100%;
  padding-bottom: 0.4rem;
  ${media.small`
    padding: 0;
  `};
`;
export const Name = styled.h3`
  display: block;
  font-size: ${p => (p.$isLongName ? '1.1rem' : '1.3rem')};
  font-weight: normal;
  margin: 0;
  text-overflow: ellipsis;
  min-height: 3rem;
  max-height: 3rem;
  text-align: left;
  color: ${p => p.theme.primaryColor};
  cursor: pointer;
  overflow: hidden;
  word-break: normal;
  overflow-wrap: break-word;
  ${media.medium`
    font-size: ${p => (p.$isLongName ? '1.1rem' : '1.2rem')};
    min-height: 2.8rem;
    max-height: 2.8rem;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  `};
`;

export const ButtonStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  font-size: 1.4rem;
  padding: 0.5rem 1rem 1rem 12rem;
  ${media.small`
    padding-left: 15rem;
    padding-right: 1rem;
    flex-grow: 1;
    max-width: 100%;
    a {
      width: 100%;
      max-width: 100%;
    }
  `};
  ${media.smaller`
    font-size: 1.2rem;
  `};
`;

export const Details = styled(Content)`
  padding: 0;
  width: 100%;
  flex-direction: column;
  text-align: center;
  justify-content: flex-end;
`;

export const PriceWrapper = styled.div`
  width: 100%;
  font-size: 1.4rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding-bottom: 0.5rem;
  ${media.small`
    line-height: 1.4rem;
    min-height: auto;
  `};
  ${media.smaller`
    padding: ${p => (p.$extraPadding ? '0.5rem 0 1rem' : 0)};
  `};
`;

export const Description = styled.span`
  display: block;
  font-size: 1.3rem;
  color: ${p => p.theme.textColor};
  line-height: 2rem;
  max-height: 4rem;
  height: 4rem;
  width: 100%;
  max-width: 100%;
  word-wrap: break-word;
  text-overflow: ellipsis;
  text-align: left;
  cursor: pointer;
  overflow: hidden;
  ${media.medium`
    font-size: 1.2rem;
    line-height: 1.6rem;
    margin-top: 0;
  `};
  ${media.small`
    line-height: 1.2rem;
  `};
  ${media.smaller`
    display: none;
  `};
`;

export const PromoWrapper = styled.div`
  text-align: center;
  width: 100%;
  height: 2rem;
  min-height: 2rem;
  max-height: 2rem;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${media.smaller`
    height: 1.6rem;
    flex-direction: column;
    min-height: 2.6rem;
    max-height: 2.6rem;
  `};
  ${media.smallest`
    align-items: flex-start;
    flex-direction: column;
    height: 2.2rem;
    min-height: 2.2rem;
    max-height: 2.2rem;
  `};
`;

export const SubWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-grow: 1;
  ${media.small`
    margin-top: 0.5rem;
  `};
`;

export const TagsWrapper = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  ${media.small`
    position: relative;
    margin-top: -1rem;
  `};
`;

export const ListId = styled(Id)`
  font-size: 1.4rem;
  padding-bottom: 0.4rem;
  color: ${p => p.theme.quinaryTextColor};
  ${media.small`
    max-width: 10rem;
  `}
  ${media.smaller`
    padding-left: 0;
  `}
`;

export const IdWrapper = styled.div`
  display: flex;
`;

export const PriceUnavailable = styled.div`
  height: 6.5rem;
  display: flex;
  align-items: center;
`;

export const ExtraPromo = styled.div`
  color: ${p => p.theme.blackColor};
  font-size: 1.4rem;
  font-weight: bold;
  width: 100%;
  text-align: left;
`;

export const SmallExtraPromo = styled(ExtraPromo)`
  font-size: 1.4rem;
  ${media.medium`
   font-size: 1.3rem;
  `};
`;

export const SmallPriceWholeWrapper = styled(PriceWholeWrapper)`
  margin-top: ${p => (p.$hasNoOffers ? '3.3rem' : 0)};
`;

export const ListPriceWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: flex-end;
  min-height: 1.5rem;
  line-height: 1.5rem;
  ${media.small`
    justify-content: flex-end;
    margin-bottom: ${p => (p.$extraBottom ? '0.5rem' : 0)};
  `};
`;

export const PriceColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${p =>
    p.$showDivider &&
    `
    border-top: 1px solid ${p.theme.borderColor};
    margin-top: 0.4rem;
    padding-top: 0.4rem;
  `};
  ${media.small`
    ${p =>
      p.$showDivider &&
      `
      border-top: 1px solid ${p.theme.borderColor};
      margin-top: 0.4rem;
      padding-top: 0.4rem;
    `};
  `};
`;

export const PriceBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: flex-start;
`;
